
import {Injectable} from "@angular/core";
import * as moment from 'moment';

import {BaseConverter} from "../../base/converters/base-converter.converter";
import {ModifyProductStateModel} from "../models/modifyProductState.model";
import {ModifyProductState} from "../../shared/DTO/modifyProductState";


@Injectable()
export class ModifyProductStateConverter extends BaseConverter<ModifyProductStateModel, ModifyProductState> {
  convertToDto(model: ModifyProductStateModel): ModifyProductState {
    if (!model) {
      return;
    }
    return {
      additionalReasons: model.additionalReasons,
      files: model.files,
      newState: model.newState,
      note: model.note,
      reason: model.reason,
      reactivationDate: moment(model.reactivationDate).toISOString()
    };
  }

  convertToModel(dto: ModifyProductState): ModifyProductStateModel {
    if (!dto) {
      return;
    }
    let model: ModifyProductStateModel = new ModifyProductStateModel();
    model.reason = dto.reason;
    model.note = dto.note;
    model.newState = dto.newState;
    model.files = dto.files;
    model.additionalReasons = dto.additionalReasons;
    model.reactivationDate = dto.reactivationDate;
    return model;
  }

}
